
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feather feather-activity",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg","class":"feather feather-activity"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_7604_5039)"}},[_c('path',{attrs:{"d":"M12.022 2.56c.198.597.45 1.198.758 1.8l.003.008a15.59 15.59 0 002.122 3.078l.008.008.006.008a18.765 18.765 0 002.92 2.586l.005.003c1.19.844 2.414 1.486 3.667 1.916-.74.258-1.485.606-2.234 1.038l-.007.004c-1.032.605-2 1.311-2.905 2.116l-.384.351c-1.014.934-1.858 1.93-2.524 2.991h0c-.625.997-1.107 1.978-1.431 2.939a13.447 13.447 0 00-1.084-2.344l-.341-.566c-.98-1.583-2.358-3.022-4.105-4.328h.001c-1.317-.996-2.66-1.736-4.024-2.204a15.184 15.184 0 003.731-1.907l.002-.001A15.905 15.905 0 0010.26 6l.002-.003c.777-1.137 1.368-2.283 1.76-3.437z","stroke":"currentColor","stroke-width":"2"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_7604_5039"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    